import { useEffect, useState } from 'react';

export const useError = (getLabel) => {
	const [error, setError] = useState('');
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		if (error && getLabel) {
			const errorMessages = getLabel('errors');
			setErrorMessage(errorMessages[error] || errorMessages['unknown'] || 'An unknown error occurred');
		}
	}, [error, getLabel]);

	return { errorMessage, setError };
};
